/*
 mapping of hooks to integrate with third party
 testing software in a consistent fashion

 anyone writing tests on this project where they need access
 to certain elements in the dom is to use these hooks
 since they are what is used in the application to generate
 the 'data-test-id' attributes
 */
import populateObjectUniquely from './utils/populate-object-uniquely/populate-object-uniquely'

const errors = {
  email:    '',
  password: '',
}

const buttons = {
  cancel:                   '',
  save:                     '',
  login:                    '',
  burger:                   '',
  scheduleNextAppointment:  '',
  confirmSessionCompletion: '',
  languageSetting:          '',
  sessionFilter:            {
    all:       '',
    completed: '',
    scheduled: '',
    tba:       '',
  },
}

const sessionByStatus = {
  completed: '',
  scheduled: '',
  tba:       '',
}

const session = {
  number: '',
  icon:   '',
  date:   '',
  time:   '',
}

const tools = {
  profile:  '',
  settings: '',
  logout:   '',
}

const hooks = {
  errors,
  buttons,
  tools,
  sessionByStatus,
  session,
  settingsListItem:        '',
  sidebarMenuTitleItem:    '',
  drawerMenuListItem:      '',
  drawerMenuListItemText:  '',
  mainAreaTitle:           '',
  changeLanguageEs:        '',
  changeLanguageEn:        '',
  languageChangedSnackBar: '',
  blc:                     '',
}

export default populateObjectUniquely(hooks)



// WEBPACK FOOTER //
// ./src/testing-hooks.ts